import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useOptyColumnStore = defineStore(
  'save', 
  () => {
    const optyColumn = ref([])
    
    function saveoptyColumnData(data){
        optyColumn.value = data
    }

    return { optyColumn , saveoptyColumnData}
  },
  {
    persist: true,
  },
)